module.exports = __webpack_public_path__ + "static/media/2.0-logo.db75ca6a.svg";